import * as Yup from "yup";

export const schemaForgotPassword = Yup.object().shape({
  email: Yup.string().email().required(),
});
